import { useState } from "react";
import { post } from "utils/request";
import { toast } from "react-toastify";
import { postPollResponse } from "apis/poll";
import { useRouter } from "components/hooks";
import { TOAST_CONFIG } from "../../../constants";
import PollModal from "./PollModal";

type Props = {
  isModalOpen: boolean;
  onModalClose: () => void;
  pollId: string;
  pollData: any;
  refetch: () => void;
  isRefetching: boolean;
};

function UserPollModalContainer({ isModalOpen, onModalClose, pollId, pollData, refetch, isRefetching }: Props) {
  const [loading, setLoading] = useState(false);

  const router = useRouter();
  const { magnetId } = router.query;

  const handlePollResponseSuccess = () => {
    refetch();
    setLoading(false);
  };

  const handlePollResponseError = (errorMessage: string) => {
    setLoading(false);
    toast.error(errorMessage, TOAST_CONFIG);
    throw new Error(errorMessage);
  };

  const handlePollResponse = (payload: { response: number[] }) => {
    post(postPollResponse(magnetId, pollId), payload, {
      processData: handlePollResponseSuccess,
      processError: handlePollResponseError,
    });
  };

  const handlePollSubmit = (pollOptionIndex: number[]) => {
    setLoading(true);
    const payload = { response: pollOptionIndex.map((response) => response + 1) };
    handlePollResponse(payload);
  };

  const maxVotePercentages = pollData.choices.map((choices: any) =>
    Math.max(...choices.map((choice: any) => choice.percentage || -1)),
  );

  console.log(pollData);

  return (
    <PollModal
      maxVotePercentages={maxVotePercentages}
      pollData={pollData}
      isModalOpen={isModalOpen}
      onModalClose={onModalClose}
      handlePollSubmit={handlePollSubmit}
      loading={loading}
      refetch={refetch}
      isRefetching={isRefetching}
    />
  );
}
export default UserPollModalContainer;
